interface PlaceholderPageProps {
  title: string;
  eyebrow?: string;
  description?: string;
}

export function PlaceholderPage({ title, eyebrow = "Production surface", description }: PlaceholderPageProps) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm ">
      <p className="text-xs font-black uppercase tracking-[.28em] text-slate-500">{eyebrow}</p>
      <h1 className="mt-3 text-4xl font-black">{title}</h1>
      <p className="mt-4 max-w-2xl text-slate-600">
        {description ?? "Route is wired for the production frontend buildout. The next implementation slice replaces this placeholder with domain-specific components and tested workflow state."}
      </p>
    </section>
  );
}
